import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { ICouponFilterBody } from "@/api_framework/api_modals/coupon";
import { setCouponListing } from "@/app_redux/reducers/slices/auth/coupon_service_slice";

AxiosCurlirize(axios, () => {});

export const useCouponListingAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (
      filterBody: ICouponFilterBody,
      searchKeyword: string,
      pageNumber: number,
      pageSize: string,
      exportCSV = false,
    ) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(
            `${COUPON_SERVICE_APIS?.COUPON_LISTING_NEW?.baseURL}?page_number=${pageNumber}&page_size=${pageSize}&search=${searchKeyword}`,
            filterBody,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
              responseType: exportCSV ? "blob" : "json",
            },
          )
          .then((res: AxiosResponse<any>) => {
            // CSV DOWNLOAD
            if (exportCSV) {
              const blob = new Blob([res.data], {
                type: "text/csv",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "coupon-list.csv");
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);
              return;
            }
            // NORMAL TABLE LISTING
            if (res.data.status) {
              dispatch(setCouponListing({ data: res?.data?.data }));
              dispatch(
                setLoading({
                  key: "isCouponServiceListInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(
                setLoading({
                  key: "isCouponServiceListInProgress",
                  status: false,
                }),
              );
              dispatch(setCouponListing({ data: null }));
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isCouponServiceListInProgress",
                status: false,
              }),
            );
            dispatch(setCouponListing({ data: null }));
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "product_not_filtered" };
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
